import React from "react";
import DataTable from "react-data-table-component";
import Swal from "sweetalert2";
import {
  Button,
  Card,
  Col,
  Container,
  Form,
  InputGroup,
  Modal,
  Row,
} from "react-bootstrap";
import {
  createCabangMaster,
  createClientMaster,
  createPerusahaan,
  deleteCabangMaster,
  deleteClientMaster,
  deletePerusahaan,
  getAllCabangMaster,
  getAllClientMaster,
  getAllPerusahaan,
  updateCabangMaster,
  updateClientMaster,
  updatePerusahaan,
} from "../../stores";

const EMPTY_FORMS = {
  perusahaan: {
    idPerusahaan: "",
    namaPerusahaan: "",
    softDelete: false,
  },
  client: {
    idClient: "",
    idPerusahaan: "",
    namaClient: "",
    softDelete: false,
  },
  cabang: {
    idCabang: "",
    idPerusahaan: "",
    idClient: "",
    namaCabang: "",
    kotaCabang: "",
    provinsiCabang: "",
    softDelete: false,
  },
};

function getApiMessage(response, fallback) {
  return response?.data?.message || fallback;
}

function statusLabel(value) {
  return value ? "Soft Delete" : "Aktif";
}

function StatusBadge({ value }) {
  return (
    <span
      style={{
        backgroundColor: value ? "#FEE2E2" : "#DCFCE7",
        color: value ? "#991B1B" : "#166534",
        borderRadius: 6,
        display: "inline-block",
        fontWeight: "bold",
        padding: "8px 10px",
      }}
    >
      {statusLabel(value)}
    </span>
  );
}

function formatDateTime(value) {
  if (!value) {
    return "-";
  }

  const date = new Date(value);
  if (Number.isNaN(date.getTime())) {
    return "-";
  }

  return date.toLocaleString("id-ID");
}

function IdCell({ value }) {
  return (
    <span
      style={{
        display: "block",
        fontFamily: "monospace",
        lineHeight: 1.35,
        overflowWrap: "anywhere",
        whiteSpace: "normal",
        wordBreak: "break-word",
      }}
      title={value || "-"}
    >
      {value || "-"}
    </span>
  );
}

function DetailItem({ label, children, mono }) {
  return (
    <Col md="6">
      <div style={{ marginBottom: 16 }}>
        <div style={{ color: "#6B7280", fontSize: 13, marginBottom: 4 }}>
          {label}
        </div>
        <div
          style={{
            fontFamily: mono ? "monospace" : "inherit",
            fontWeight: 600,
            overflowWrap: "anywhere",
            wordBreak: "break-word",
          }}
        >
          {children || "-"}
        </div>
      </div>
    </Col>
  );
}

function MasterForm({
  activeTab,
  form,
  mode,
  companies,
  clients,
  setForm,
  onSubmit,
}) {
  return (
    <Form onSubmit={onSubmit}>
      {activeTab === "perusahaan" ? (
        <>
          <Form.Group>
            <label>ID Perusahaan</label>
            <Form.Control
              disabled={mode === "edit"}
              value={form.idPerusahaan}
              onChange={(event) =>
                setForm({ ...form, idPerusahaan: event.target.value })
              }
              required
            />
          </Form.Group>
          <Form.Group>
            <label>Nama Perusahaan</label>
            <Form.Control
              value={form.namaPerusahaan}
              onChange={(event) =>
                setForm({ ...form, namaPerusahaan: event.target.value })
              }
              required
            />
          </Form.Group>
        </>
      ) : null}

      {activeTab === "client" ? (
        <>
          <Form.Group>
            <label>ID Client</label>
            <Form.Control
              disabled={mode === "edit"}
              value={form.idClient}
              onChange={(event) =>
                setForm({ ...form, idClient: event.target.value })
              }
              required
            />
          </Form.Group>
          <Form.Group>
            <label>ID Perusahaan</label>
            <Form.Control
              as="select"
              disabled={mode === "edit"}
              value={form.idPerusahaan}
              onChange={(event) =>
                setForm({ ...form, idPerusahaan: event.target.value })
              }
              required
            >
              <option value="">Pilih perusahaan</option>
              {companies
                .filter((item) => !item.softDelete)
                .map((item) => (
                  <option key={item.idPerusahaan} value={item.idPerusahaan}>
                    {item.idPerusahaan} - {item.namaPerusahaan}
                  </option>
                ))}
            </Form.Control>
          </Form.Group>
          <Form.Group>
            <label>Nama Client</label>
            <Form.Control
              value={form.namaClient}
              onChange={(event) =>
                setForm({ ...form, namaClient: event.target.value })
              }
              required
            />
          </Form.Group>
        </>
      ) : null}

      {activeTab === "cabang" ? (
        <>
          <Form.Group>
            <label>ID Cabang</label>
            <Form.Control
              disabled={mode === "edit"}
              value={form.idCabang}
              onChange={(event) =>
                setForm({ ...form, idCabang: event.target.value })
              }
              required
            />
          </Form.Group>
          <Form.Group>
            <label>ID Perusahaan</label>
            <Form.Control
              as="select"
              disabled={mode === "edit"}
              value={form.idPerusahaan}
              onChange={(event) =>
                setForm({
                  ...form,
                  idPerusahaan: event.target.value,
                  idClient: "",
                })
              }
              required
            >
              <option value="">Pilih perusahaan</option>
              {companies
                .filter((item) => !item.softDelete)
                .map((item) => (
                  <option key={item.idPerusahaan} value={item.idPerusahaan}>
                    {item.idPerusahaan} - {item.namaPerusahaan}
                  </option>
                ))}
            </Form.Control>
          </Form.Group>
          <Form.Group>
            <label>ID Client</label>
            <Form.Control
              as="select"
              disabled={mode === "edit"}
              value={form.idClient}
              onChange={(event) =>
                setForm({ ...form, idClient: event.target.value })
              }
              required
            >
              <option value="">Pilih client</option>
              {clients
                .filter(
                  (item) =>
                    !item.softDelete && item.idPerusahaan === form.idPerusahaan,
                )
                .map((item) => (
                  <option key={item.idClient} value={item.idClient}>
                    {item.idClient} - {item.namaClient}
                  </option>
                ))}
            </Form.Control>
          </Form.Group>
          <Form.Group>
            <label>Nama Cabang</label>
            <Form.Control
              value={form.namaCabang}
              onChange={(event) =>
                setForm({ ...form, namaCabang: event.target.value })
              }
              required
            />
          </Form.Group>
          <Row>
            <Col md="6">
              <Form.Group>
                <label>Kota Cabang</label>
                <Form.Control
                  value={form.kotaCabang}
                  onChange={(event) =>
                    setForm({ ...form, kotaCabang: event.target.value })
                  }
                />
              </Form.Group>
            </Col>
            <Col md="6">
              <Form.Group>
                <label>Provinsi Cabang</label>
                <Form.Control
                  value={form.provinsiCabang}
                  onChange={(event) =>
                    setForm({ ...form, provinsiCabang: event.target.value })
                  }
                />
              </Form.Group>
            </Col>
          </Row>
        </>
      ) : null}

      <Button className="btn-fill pull-right" type="submit" variant="info">
        {mode === "edit" ? "Update" : "Simpan"}
      </Button>
      <div className="clearfix" />
    </Form>
  );
}

function Perusahaan() {
  const [activeTab, setActiveTab] = React.useState("perusahaan");
  const [searchText, setSearchText] = React.useState("");
  const [loading, setLoading] = React.useState(false);
  const [modal, setModal] = React.useState(false);
  const [detailModal, setDetailModal] = React.useState(false);
  const [detailData, setDetailData] = React.useState(null);
  const [mode, setMode] = React.useState("add");
  const [form, setForm] = React.useState(EMPTY_FORMS.perusahaan);
  const [companies, setCompanies] = React.useState([]);
  const [clients, setClients] = React.useState([]);
  const [branches, setBranches] = React.useState([]);

  const customStyles = {
    headRow: {
      style: {
        minHeight: "48px",
        backgroundColor: "#F8F8F8",
      },
    },
    headCells: {
      style: {
        minHeight: 48,
        fontWeight: "bold",
        fontSize: 14,
      },
    },
    rows: {
      style: {
        minHeight: "64px",
        fontSize: 14,
      },
    },
    cells: {
      style: {
        alignItems: "center",
        whiteSpace: "normal",
      },
    },
  };

  async function loadData(cari = searchText) {
    setLoading(true);
    const [companyResponse, clientResponse, branchResponse] =
      await Promise.all([
        getAllPerusahaan(null, { cari }),
        getAllClientMaster({ cari }),
        getAllCabangMaster({ cari }),
      ]);

    setLoading(false);
    if (
      companyResponse?.status !== 200 ||
      clientResponse?.status !== 200 ||
      branchResponse?.status !== 200
    ) {
      Swal.fire("Gagal", "Gagal memuat master data.", "error");
      return;
    }

    setCompanies(companyResponse.data.data || []);
    setClients(clientResponse.data.data || []);
    setBranches(branchResponse.data.data || []);
  }

  React.useEffect(() => {
    loadData("");
  }, []);

  function openAddModal() {
    setMode("add");
    setForm(EMPTY_FORMS[activeTab]);
    setModal(true);
  }

  function openEditModal(row) {
    setMode("edit");
    if (activeTab === "perusahaan") {
      setForm({
        idPerusahaan: row.idPerusahaan || "",
        namaPerusahaan: row.namaPerusahaan || "",
        softDelete: Boolean(row.softDelete),
      });
    } else if (activeTab === "client") {
      setForm({
        idClient: row.idClient || "",
        idPerusahaan: row.idPerusahaan || "",
        namaClient: row.namaClient || "",
        softDelete: Boolean(row.softDelete),
      });
    } else {
      setForm({
        idCabang: row.idCabang || "",
        idPerusahaan: row.idPerusahaan || "",
        idClient: row.idClient || "",
        namaCabang: row.namaCabang || "",
        kotaCabang: row.kotaCabang || "",
        provinsiCabang: row.provinsiCabang || "",
        softDelete: Boolean(row.softDelete),
      });
    }
    setModal(true);
  }

  function openDetailModal(row) {
    setDetailData(row);
    setDetailModal(true);
  }

  async function submitForm(event) {
    event.preventDefault();

    const requestMap = {
      perusahaan:
        mode === "edit" ? updatePerusahaan : createPerusahaan,
      client: mode === "edit" ? updateClientMaster : createClientMaster,
      cabang: mode === "edit" ? updateCabangMaster : createCabangMaster,
    };
    const response = await requestMap[activeTab](form);

    if (response?.status === 200) {
      Swal.fire("Berhasil", response.data.message, "success");
      setModal(false);
      loadData();
    } else {
      Swal.fire(
        "Gagal",
        getApiMessage(response, "Data gagal disimpan."),
        "error",
      );
    }
  }

  async function submitDelete(row) {
    const idMap = {
      perusahaan: row.idPerusahaan,
      client: row.idClient,
      cabang: row.idCabang,
    };
    const nameMap = {
      perusahaan: row.namaPerusahaan,
      client: row.namaClient,
      cabang: row.namaCabang,
    };

    const result = await Swal.fire({
      title: "Hapus master data?",
      text: `${idMap[activeTab]} - ${nameMap[activeTab] || ""}`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Hapus",
      cancelButtonText: "Batal",
    });

    if (!result.isConfirmed) {
      return;
    }

    const requestMap = {
      perusahaan: () =>
        deletePerusahaan({ idPerusahaan: row.idPerusahaan }),
      client: () => deleteClientMaster({ idClient: row.idClient }),
      cabang: () => deleteCabangMaster({ idCabang: row.idCabang }),
    };
    const response = await requestMap[activeTab]();

    if (response?.status === 200) {
      Swal.fire("Berhasil", response.data.message, "success");
      loadData();
    } else {
      Swal.fire(
        "Gagal",
        getApiMessage(response, "Data gagal dihapus."),
        "error",
      );
    }
  }

  function getActions(row) {
    return (
      <div style={{ display: "flex", gap: 8, justifyContent: "center" }}>
        <Button
          size="sm"
          variant="secondary"
          onClick={() => openDetailModal(row)}
          title="Detail"
        >
          <i className="fas fa-eye" />
        </Button>
        <Button
          size="sm"
          variant="info"
          onClick={() => openEditModal(row)}
          title="Edit"
        >
          <i className="fas fa-edit" />
        </Button>
        <Button
          size="sm"
          variant="danger"
          onClick={() => submitDelete(row)}
          title="Delete"
        >
          <i className="fas fa-trash" />
        </Button>
      </div>
    );
  }

  const columns = {
    perusahaan: [
      {
        name: "ID Perusahaan",
        selector: (row) => row.idPerusahaan,
        cell: (row) => <IdCell value={row.idPerusahaan} />,
        minWidth: "170px",
        wrap: true,
      },
      { name: "Nama Perusahaan", selector: (row) => row.namaPerusahaan, grow: 2 },
      { name: "Status", selector: (row) => statusLabel(row.softDelete), cell: (row) => <StatusBadge value={row.softDelete} />, center: true },
      { name: "Aksi", cell: getActions, center: true, width: "160px" },
    ],
    client: [
      {
        name: "ID Client",
        selector: (row) => row.idClient,
        cell: (row) => <IdCell value={row.idClient} />,
        minWidth: "180px",
        wrap: true,
      },
      {
        name: "ID Perusahaan",
        selector: (row) => row.idPerusahaan,
        cell: (row) => <IdCell value={row.idPerusahaan} />,
        minWidth: "170px",
        wrap: true,
      },
      { name: "Perusahaan", selector: (row) => row.perusahaan?.namaPerusahaan || "-", grow: 2 },
      { name: "Nama Client", selector: (row) => row.namaClient, grow: 2 },
      { name: "Status", selector: (row) => statusLabel(row.softDelete), cell: (row) => <StatusBadge value={row.softDelete} />, center: true },
      { name: "Aksi", cell: getActions, center: true, width: "160px" },
    ],
    cabang: [
      {
        name: "ID Cabang",
        selector: (row) => row.idCabang,
        cell: (row) => <IdCell value={row.idCabang} />,
        minWidth: "180px",
        wrap: true,
      },
      {
        name: "ID Client",
        selector: (row) => row.idClient,
        cell: (row) => <IdCell value={row.idClient} />,
        minWidth: "180px",
        wrap: true,
      },
      { name: "Client", selector: (row) => row.client?.namaClient || "-", grow: 2 },
      {
        name: "ID Perusahaan",
        selector: (row) => row.idPerusahaan,
        cell: (row) => <IdCell value={row.idPerusahaan} />,
        minWidth: "170px",
        wrap: true,
      },
      { name: "Nama Cabang", selector: (row) => row.namaCabang, grow: 2 },
      { name: "Kota", selector: (row) => row.kotaCabang || "-" },
      { name: "Provinsi", selector: (row) => row.provinsiCabang || "-" },
      { name: "Status", selector: (row) => statusLabel(row.softDelete), cell: (row) => <StatusBadge value={row.softDelete} />, center: true },
      { name: "Aksi", cell: getActions, center: true, width: "160px" },
    ],
  };

  const dataMap = {
    perusahaan: companies,
    client: clients,
    cabang: branches,
  };
  const titleMap = {
    perusahaan: "Perusahaan",
    client: "Client",
    cabang: "Cabang",
  };

  return (
    <>
      <Container fluid>
        <Row>
          <Col md="12">
            <Card>
              <Card.Header>
                <Card.Title as="h3" style={{ fontWeight: "bold" }}>
                  Master Data
                </Card.Title>
                <Row style={{ alignItems: "center", rowGap: 10 }}>
                  <Col md="4">
                    <InputGroup>
                      <Form.Control
                        value={searchText}
                        onChange={(event) => setSearchText(event.target.value)}
                        onKeyDown={(event) => {
                          if (event.key === "Enter") {
                            loadData();
                          }
                        }}
                        placeholder="Cari ID atau nama"
                      />
                      <InputGroup.Append>
                        <InputGroup.Text
                          style={{ cursor: "pointer" }}
                          onClick={() => {
                            setSearchText("");
                            loadData("");
                          }}
                        >
                          <i className="fas fa-times" />
                        </InputGroup.Text>
                      </InputGroup.Append>
                    </InputGroup>
                  </Col>
                  <Col md="auto">
                    <Button
                      style={{ backgroundColor: "#00BFFF", border: 0 }}
                      onClick={() => loadData()}
                    >
                      <i className="fas fa-search" />
                    </Button>
                  </Col>
                  <Col
                    style={{
                      display: "flex",
                      gap: 8,
                      justifyContent: "flex-end",
                      flexWrap: "wrap",
                    }}
                  >
                    {["perusahaan", "client", "cabang"].map((item) => (
                      <Button
                        key={item}
                        variant={activeTab === item ? "info" : "light"}
                        onClick={() => {
                          setActiveTab(item);
                          setForm(EMPTY_FORMS[item]);
                        }}
                      >
                        {titleMap[item]}
                      </Button>
                    ))}
                    <Button variant="success" onClick={openAddModal}>
                      <i className="fas fa-plus" style={{ marginRight: 8 }} />
                      Add {titleMap[activeTab]}
                    </Button>
                  </Col>
                </Row>
              </Card.Header>
              <Card.Body>
                <DataTable
                  columns={columns[activeTab]}
                  data={dataMap[activeTab]}
                  customStyles={customStyles}
                  progressPending={loading}
                  pagination
                  paginationPerPage={10}
                />
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>

      <Modal
        size="lg"
        show={modal}
        onHide={() => setModal(false)}
        aria-labelledby="master-data-modal"
      >
        <Modal.Header closeButton>
          <Modal.Title>
            {mode === "edit" ? "Edit" : "Add"} {titleMap[activeTab]}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <MasterForm
            activeTab={activeTab}
            form={form}
            mode={mode}
            companies={companies}
            clients={clients}
            setForm={setForm}
            onSubmit={submitForm}
          />
        </Modal.Body>
      </Modal>

      <Modal
        size="lg"
        show={detailModal}
        onHide={() => setDetailModal(false)}
        aria-labelledby="master-data-detail-modal"
      >
        <Modal.Header closeButton>
          <Modal.Title>Detail {titleMap[activeTab]}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {detailData ? (
            <>
              {activeTab === "perusahaan" ? (
                <Row>
                  <DetailItem label="ID Perusahaan" mono>
                    {detailData.idPerusahaan}
                  </DetailItem>
                  <DetailItem label="Nama Perusahaan">
                    {detailData.namaPerusahaan}
                  </DetailItem>
                </Row>
              ) : null}

              {activeTab === "client" ? (
                <Row>
                  <DetailItem label="ID Client" mono>
                    {detailData.idClient}
                  </DetailItem>
                  <DetailItem label="Nama Client">
                    {detailData.namaClient}
                  </DetailItem>
                  <DetailItem label="ID Perusahaan" mono>
                    {detailData.idPerusahaan}
                  </DetailItem>
                  <DetailItem label="Nama Perusahaan">
                    {detailData.perusahaan?.namaPerusahaan}
                  </DetailItem>
                </Row>
              ) : null}

              {activeTab === "cabang" ? (
                <Row>
                  <DetailItem label="ID Cabang" mono>
                    {detailData.idCabang}
                  </DetailItem>
                  <DetailItem label="Nama Cabang">
                    {detailData.namaCabang}
                  </DetailItem>
                  <DetailItem label="ID Client" mono>
                    {detailData.idClient}
                  </DetailItem>
                  <DetailItem label="Nama Client">
                    {detailData.client?.namaClient}
                  </DetailItem>
                  <DetailItem label="ID Perusahaan" mono>
                    {detailData.idPerusahaan}
                  </DetailItem>
                  <DetailItem label="Nama Perusahaan">
                    {detailData.perusahaan?.namaPerusahaan}
                  </DetailItem>
                  <DetailItem label="Kota Cabang">
                    {detailData.kotaCabang}
                  </DetailItem>
                  <DetailItem label="Provinsi Cabang">
                    {detailData.provinsiCabang}
                  </DetailItem>
                </Row>
              ) : null}

              <Row>
                <DetailItem label="Status">
                  <StatusBadge value={detailData.softDelete} />
                </DetailItem>
                <DetailItem label="Dibuat">
                  {formatDateTime(detailData.createdAt)}
                </DetailItem>
                <DetailItem label="Diupdate">
                  {formatDateTime(detailData.updatedAt)}
                </DetailItem>
              </Row>
            </>
          ) : null}
        </Modal.Body>
      </Modal>
    </>
  );
}

export default Perusahaan;
